import { motion } from "framer-motion";
import { NANCY_VIDEO_HERO } from "../../data";

const ease = [0.76, 0, 0.24, 1];

const Line = ({ children, delay }) => (
  <span className="block overflow-hidden">
    <motion.span className="block" initial={{ y: "110%" }} animate={{ y: 0 }} transition={{ duration: 1, delay, ease }}>
      {children}
    </motion.span>
  </span>
);

export const AboutHero = () => (
  <section className="pt-32 md:pt-44 pb-12 md:pb-20" data-testid="about-hero">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12 grid md:grid-cols-12 gap-10 md:gap-16 items-center">
      <div className="md:col-span-6">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.4 }}
          className="text-xs uppercase tracking-[0.35em] text-champagne mb-6 md:mb-10"
        >
          Designer & Founder
        </motion.p>
        <h1 className="font-serif font-light leading-[0.9] tracking-tight text-6xl md:text-8xl lg:text-[7vw]">
          <Line delay={0.15}>The maker</Line>
          <Line delay={0.28}>behind <span className="italic">NK</span></Line>
        </h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="mt-8 md:mt-12 max-w-xl text-base md:text-lg font-light text-ink/70 leading-relaxed"
        >
          Nancy Khau is the designer, dressmaker and heart behind NK Bridal Australia — creating custom, one-of-a-kind gowns by hand since 2013.
        </motion.p>
      </div>

      <div className="md:col-span-6">
        <motion.div
          initial={{ clipPath: "inset(100% 0% 0% 0%)" }}
          animate={{ clipPath: "inset(0% 0% 0% 0%)" }}
          transition={{ duration: 1.3, delay: 0.5, ease }}
          className="relative overflow-hidden aspect-[4/5] border border-line bg-stone"
        >
          <video
            src={NANCY_VIDEO_HERO}
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-full object-cover"
            data-testid="about-hero-video"
          />
        </motion.div>
      </div>
    </div>
  </section>
);
